/**
 * CartHike Blocker
 * CartHike was uninstalled but its Shopify Script Tag persists.
 * This script intercepts document.createElement to block any script
 * from carthike.com from being loaded.
 */
(function() {
  'use strict';
  var _orig = document.createElement.bind(document);
  document.createElement = function(tagName) {
    var el = _orig(tagName);
    if (tagName && tagName.toLowerCase() === 'script') {
      var proto = HTMLScriptElement.prototype;
      var srcDesc = Object.getOwnPropertyDescriptor(proto, 'src');
      Object.defineProperty(el, 'src', {
        set: function(val) {
          if (typeof val === 'string' && val.indexOf('carthike') !== -1) {
            // Block and log
            if (window.console && console.warn) {
              console.warn('[CartHike Blocker] Blocked orphaned script:', val);
            }
            return;
          }
          srcDesc.set.call(this, val);
        },
        get: function() {
          return srcDesc.get.call(this);
        },
        configurable: true
      });
    }
    return el;
  };
})();